import { useMemo } from 'react';
import { useQuery } from 'react-query';
import HouseholdService from 'services/householdService';
import useAbortController from 'hooks/useAbortController';
import { QK_HOUSEHOLD_NOTIFICATIONS } from './constants';

export const useFetchHouseholdNotifications = (
  organizationId: string,
  propertyId: string,
  householdId: string,
) => {
  const householdService = useMemo(() => new HouseholdService(), []);
  const abortControllerOptions = useAbortController();

  return useQuery({
    queryKey: [QK_HOUSEHOLD_NOTIFICATIONS, householdId],
    queryFn: async () => {
      return await householdService.getHouseholdNotifications(
        organizationId,
        propertyId,
        householdId,
        abortControllerOptions,
      );
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};
